export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/udlm2cge_Logo%20BMFG.jpg";

export const WHATSAPP_NUMBER = "528126672407";

export const ANGEL_URL =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/e856ewyu_image.png";
export const WHATSAPP_LINK =
  "https://wa.me/528126672407?text=" +
  encodeURIComponent(
    "Hola, me gustaría recibir más información sobre BM Grupo Financiero."
  );

export const IMG = {
  heroArch:
    "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  missionTrust:
    "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  monterrey:
    "https://images.pexels.com/photos/18983477/pexels-photo-18983477.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const CONTACT = {
  telefono: "+52 81 2667 2407",
  whatsapp: "+52 81 2667 2407",
  email: "contacto@bmgrupofinanciero.com",
  sitio: "www.bmgrupofinanciero.com",
  ubicacion: "San Pedro Garza García, Nuevo León, México",
};

export const FACTORS = [
  {
    icon: "Layers",
    title: "Sobreoferta de proyectos",
    desc: "Un número elevado de nuevos participantes ingresó al mercado de forma simultánea, rompiendo el equilibrio entre oferta y demanda.",
  },
  {
    icon: "TrendingDown",
    title: "Entorno económico",
    desc: "Desde 2018, la incertidumbre llevó a inversionistas a posturas conservadoras; el capital migró a instrumentos de menor riesgo.",
  },
  {
    icon: "Landmark",
    title: "Reacción de la banca",
    desc: "El alza en las tasas de los instrumentos de ahorro hizo difícil competir con los rendimientos bancarios.",
  },
  {
    icon: "ShieldAlert",
    title: "La pandemia",
    desc: "En 2020 las obras pararon pero los costos siguieron. Créditos puente y compromisos continuaron generando obligaciones.",
  },
  {
    icon: "LineChart",
    title: "Inflación",
    desc: "La plusvalía pasó de ~6% a más de 25% anual. Las utilidades no alcanzaban para recomprar tierra equivalente.",
  },
  {
    icon: "FileSignature",
    title: "Condicionantes financieros",
    desc: "Los créditos puente exigían 25–50% del proyecto en preventa, obligando a vender a precios que el tiempo haría insuficientes.",
  },
  {
    icon: "Droplets",
    title: "Crisis hídrica",
    desc: "Entre 2021 y 2022 las presas alcanzaron mínimos históricos; las factibilidades de agua quedaron suspendidas.",
  },
  {
    icon: "Zap",
    title: "Saturación eléctrica",
    desc: "Obtener una factibilidad de la CFE comenzó a tomar de 12 a 36 meses. Sin luz no hay entrega; sin entrega no hay liquidación.",
  },
  {
    icon: "Stamp",
    title: "Trámites y permisos",
    desc: "Procesos administrativos complejos generaron retrasos de meses e incluso años, sumando costo financiero sin ingresos.",
  },
];

export const TARANTELLA_LOGO =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/5ytk0yar_fnf-01.jpg";

export const LALO_IMG =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/8u59snv9_image.png";
export const LALO_RENDER =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/j3bz1s77_image.png";
export const LALO_OBRA =
  "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/i72zrbbj_image.png";

export const CLIENTS = [
  {
    name: "Wellmedic Health Centers",
    src: "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/cphsgei0_image.png",
    boost: true,
  },
  {
    name: "Abella Desarrollos",
    src: "https://customer-assets.emergentagent.com/job_entry-point-187/artifacts/me82nyxa_image.png",
  },
];

export const NAV_LINKS = [
  { id: "manifiesto", label: "Nuestro propósito" },
  { id: "quienes-somos", label: "Quiénes somos" },
  { id: "contexto", label: "El contexto" },
  { id: "soluciones", label: "Soluciones" },
  { id: "modelo", label: "Modelo" },
  { id: "proyectos", label: "Proyectos" },
  { id: "contacto", label: "Contacto" },
];
